export default __webpack_public_path__ + "static/media/Groupe 8895.d58550d7.svg";